import { render } from "./StatisticsPanel.vue?vue&type=template&id=6e8fbd7f&scoped=true"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js"

import "./StatisticsPanel.vue?vue&type=style&index=0&id=6e8fbd7f&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8fbd7f"]])

export default __exports__